import React, { Component } from 'react';

class Banner extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                { id: 1, icon: 'fa fa-check', title: 'Aprende de los expertos' },
                { id: 2, icon: 'fa fa-check', title: 'Incluye 5 capítulos' },
                { id: 3, icon: 'fa fa-check', title: 'Elige tu formato favorito tapa dura o tapa blanda' },
                { id: 4, icon: 'fa fa-check', title: 'Incluye ejemplos MATLAB que podrás descargar de la web del libro' },
            ],
            amazonLinks: [
                { country: "US", url: "https://www.amazon.com/dp/840976203X?maas=maas_adg_5D3B5D476A41185CD9D0075ED74588D7_afap_abs&ref_=aa_maas&tag=maas", flag: "us.png", currency: "USD" },
                { country: "UK", url: "https://www.amazon.co.uk/dp/840976203X?maas=maas_adg_2380B854318D3EC709F4400CCB2BCD7E_afap_abs&ref_=aa_maas&tag=maas", flag: "gb.png", currency: "GBP" },
                { country: "DE", url: "https://www.amazon.de/dp/840976203X?maas=maas_adg_8A4A1243AF9226603BB25D99FCE73166_afap_abs&ref_=aa_maas&tag=maas", flag: "de.png", currency: "EUR" },
                { country: "FR", url: "https://www.amazon.fr/dp/840976203X?maas=maas_adg_375099402E9609BC757AE5AD99A16277_afap_abs&ref_=aa_maas&tag=maas", flag: "fr.png", currency: "EUR" },
                { country: "ES", url: "https://www.amazon.es/dp/840976203X?maas=maas_adg_6A720AC813E1AD9C76ADB9263BD33E21_afap_abs&ref_=aa_maas&tag=maas", flag: "es.png", currency: "EUR" },
                { country: "IT", url: "https://www.amazon.it/dp/840976203X?maas=maas_adg_B098D7F6010D669676C96BF73637DA59_afap_abs&ref_=aa_maas&tag=maas", flag: "it.png", currency: "EUR" },
                { country: "NL", url: "https://www.amazon.nl/dp/840976203X?maas=maas_adg_3D8D899491E1FFD5D27F4425F387FC92_afap_abs&ref_=aa_maas&tag=maas", flag: "nl.png", currency: "EUR" },
                { country: "PL", url: "https://www.amazon.pl/dp/840976203X", flag: "pl.png", currency: "PLN" },
                { country: "SE", url: "https://www.amazon.se/dp/840976203X", flag: "se.png", currency: "SEK" },
                { country: "JP", url: "https://www.amazon.co.jp/dp/840976203X", flag: "jp.png", currency: "JPY" },
                { country: "CA", url: "https://www.amazon.ca/dp/840976203X?maas=maas_adg_7EC09E874A5E5EECA12B0FB8A943209D_afap_abs&ref_=aa_maas&tag=maas", flag: "ca.png", currency: "CAD" },
                { country: "AU", url: "https://www.amazon.com.au/dp/840976203X", flag: "au.png", currency: "AUD" },
            ],
            showDropdown: false
        };

        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleDocumentClick = (e) => {
        if (!this.dropdownRef.current) return;
        if (this.state.showDropdown && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ showDropdown: false });
        }
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.showDropdown) {
            this.setState({ showDropdown: false });
        }
    }

    toggleDropdown = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState(prev => ({ showDropdown: !prev.showDropdown }));
    }

    handleAmazonClick = async (link, e) => {
      try {
        const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
          ? 'https://controlbook.onrender.com'
          : 'http://localhost:3000';
    
        await fetch(`${backendUrl}/clicks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "amazon-CompraAhora" + link.country.toLowerCase(),
            pageUrl: window.location.href,
            elementType: "link",
            userId: "user-react",
            coordinates: { x: 100, y: 200 },
            metadata: {
              country: link.country,
              currency: link.currency,
              store: "amazon",
              product: "neural-networks-book"
            }
          }),
        });
      } catch (err) {
        console.error('Error recording click', err);
      }
    
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-16832649503/ItwECMuR6ZIbEJ-yt9o-",
          value: 1.0,
          currency: link.currency,
        });
      }
      
      this.setState({ showDropdown: false });
    };

    handleLeanpubClick = async (event) => {
      try {
        const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
          ? 'https://controlbook.onrender.com'
          : 'http://localhost:3000';

        await fetch(`${backendUrl}/clicks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "leanpub-comprar-digital",
            pageUrl: window.location.href,
            elementType: "button",
            userId: "user-react",
            coordinates: { x: event.clientX, y: event.clientY },
            metadata: {
              store: "leanpub",
              product: "neural-networks-book",
              type: "digital"
            }
          }),
        });
      } catch (err) {
        console.error('Error recording Leanpub click', err);
      }

      // Redirigir a Leanpub
      window.open("https://leanpub.com/neuralnetandadaptivecontrol", "_blank", "noopener noreferrer");
    };

    render() {
        return (
            <section className="banner pb-80">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-6">
                            <div className="banner-img pe-3">
                                <img src="assets/images/banner/book-2.png" alt="" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content mt-4 mt-lg-0">
                                <span className="subheading">Descuentos según temporada</span>
                                <h1>Todo lo que Necesitas Saber Sobre Control Adaptativo Empleando Redes Neuronales</h1>
                                <ul>
                                    {this.state.listItem.map((data, i) => (
                                        <li key={i}><i className={data.icon}></i> {data.title}</li>
                                    ))}
                                </ul>

                                {/* Dropdown Amazon */}
                                <div className="dropdown mb-3" ref={this.dropdownRef}>
                                    <button
                                        className="btn btn-main dropdown-toggle"
                                        type="button"
                                        aria-haspopup="true"
                                        aria-expanded={this.state.showDropdown}
                                        onClick={this.toggleDropdown}
                                    >
                                        Compra en Amazon Versión Impresa
                                    </button>

                                    <div
                                        className={`dropdown-menu ${this.state.showDropdown ? 'show' : ''}`}
                                        style={{ maxHeight: 300, overflowY: 'auto' }}
                                    >
                                        {this.state.amazonLinks.map((link) => (
                                            <a
                                                key={link.country}
                                                href={link.url}
                                                className="dropdown-item d-flex align-items-center"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => this.handleAmazonClick(link, e)}
                                            >
                                                <img
                                                    src={`https://flagcdn.com/w20/${link.flag}`}
                                                    alt={link.country}
                                                    style={{ width: 20, marginRight: 8 }}
                                                />
                                                <span>Amazon {link.country}</span>
                                            </a>
                                        ))}
                                    </div>
                                </div>

                                {/* Botón Leanpub */}
                                <button
                                  className="btn btn-danger mb-3"
                                  onClick={this.handleLeanpubClick}
                                >
                                  Comprar versión digital en Leanpub
                                </button>

                                <p>
                                  ¿Interesado en un capítulo gratuito?{" "}
                                  <a
                                    href="/preview_merged_sp.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(event) => {
                                      const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
                                        ? 'https://controlbook.onrender.com'
                                        : 'http://localhost:3000';
                                
                                      fetch(`${backendUrl}/clicks`, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                          sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                          elementId: "descarga-capitulo-gratis",
                                          pageUrl: window.location.href,
                                          elementType: "link", 
                                          userId: "user-react",
                                          coordinates: { x: event.clientX, y: event.clientY },
                                          metadata: {
                                            document: "preview_merged.pdf",
                                            type: "free-chapter",
                                            action: "download"
                                          }
                                        }),
                                      }).catch(err => console.error('Error tracking click:', err));
                                    }}
                                  >
                                    Obtenlo ahora
                                  </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Banner;
